import { Grid, styled } from '@mui/material';

export const ContentCalendar = styled('div')(({ theme }) => ({
    padding: theme.spacing(3),
}));

export const GridLine = styled(Grid)({
    textAlign: 'center',
});
